export default __webpack_public_path__ + "static/media/toggle-little-city-lilo.ad8d5bc3.png";